import { ChakraProvider } from "@chakra-ui/react";
import "./styles/globals.scss";
import { customTheme } from "./theme";
import Router from "routes";

export const App = () => (
  <ChakraProvider theme={customTheme}>
      <Router />
  </ChakraProvider>
)